import React from 'react';
import { Tabs, Tab } from '@mui/material';

interface OperatorTabsProps {
    operators: string[];
    selectedTab: string;
    setSelectedTab: (tab: string) => void;
}

export const OperatorTabs = ({ operators, selectedTab, setSelectedTab } : OperatorTabsProps) => {
    return (
        <Tabs 
            value={selectedTab} 
            onChange={(_, v) => setSelectedTab(v)}
            variant="scrollable" 
            scrollButtons="auto"
            TabIndicatorProps={{ style: { display: 'none' } }}
            sx={{ mb: 3, minHeight: 32 }}
        >
            {operators.map((op: string) => (
                <Tab 
                    key={op} 
                    value={op} 
                    label={op} 
                    sx={{ 
                        textTransform: 'none', fontWeight: 600, fontSize: '0.85rem', minHeight: 32, borderRadius: 4, mx: 0.5, px: 2, py: 0.5,
                        color: selectedTab === op ? '#fff !important' : 'text.secondary',
                        bgcolor: selectedTab === op ? 'primary.main' : 'transparent',
                        border: selectedTab === op ? 'none' : '1px solid #e2e8f0',
                        transition: 'all 0.2s'
                    }} 
                />
            ))}
            <Tab 
                value="SC_GLOBAL" 
                label="SC Overview" 
                sx={{ 
                    textTransform: 'none', fontWeight: 600, fontSize: '0.85rem', minHeight: 32, borderRadius: 4, ml: 2, px: 2, py: 0.5,
                    color: selectedTab === 'SC_GLOBAL' ? '#fff !important' : '#0f172a',
                    bgcolor: selectedTab === 'SC_GLOBAL' ? '#0f172a' : '#f1f5f9',
                    transition: 'all 0.2s'
                }} 
            />
        </Tabs>
    );
};